import { Button } from "components/Button/Button";
import { InputComponentProps } from "components/Form/components/InputComponentProps";
import { Password } from "components/Form/components/Password/Password";
import { Textarea } from "components/Form/components/Textarea/Textarea";
import { IconCollection } from "components/Icon/IconCollection";
import { useEffect, useRef, useState } from "react";
import "./WriteOnlyInput.scss";

export type WriteOnlyInputProps = {
    identifier: string;
    value: any;
    attributes?: any; // TODO consider improvement
    touched: boolean;
    errorMessage: string;
    hasValue: boolean;
    isMultiline: boolean;
    isFormSubmitted: boolean;
    input: InputComponentProps<string>;
};

export const WriteOnlyInput = ({
    identifier,
    value,
    attributes,
    touched,
    errorMessage,
    hasValue,
    isMultiline,
    isFormSubmitted,
    input,
}: WriteOnlyInputProps) => {
    const [isFieldOpened, setFieldOpened] = useState(false);
    const inputRef = useRef<any>();

    const changeToInputField = () => {
        setFieldOpened(true);
    };
    const changeToButton = () => {
        setFieldOpened(false);
    };

    useEffect(() => {
        if (isFormSubmitted) {
            changeToButton();
        }
    }, [isFormSubmitted]);

    useEffect(() => {
        if (isFieldOpened && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isFieldOpened]);

    const label = `${hasValue ? "Change" : "Set"} ${identifier}`;

    return isFieldOpened ? (
        isMultiline ? (
            <Textarea
                name={identifier}
                inputProps={{ ...input, value: value }}
                attributes={attributes}
                inputRef={inputRef}
            />
        ) : (
            <div className="inputField">
                <Password
                    input={input}
                    attributes={attributes}
                    name={identifier}
                    touched={touched}
                    errorMessage={errorMessage}
                    inputRef={inputRef}
                />
            </div>
        )
    ) : (
        <Button
            onClick={changeToInputField}
            icon={IconCollection.key}
            variation="dark"
            label={label}
        />
    );
};
